<script>
import axios from 'axios';
import AS from '@/services/AuthenticationService';


export default {
  acceptLegalTerms() {
    return axios.get('/users/accepted_term', AS.getDefaultHeaders());
  },
  activate(confirmation) {
    return axios.get('/users/confirmation', { params: { confirmation_token: confirmation } });
  },
  getCurrentUser() {
    return axios.get('/users/me', AS.getDefaultHeaders());
  },
  createUser(userParams) {
    return axios.post('users', userParams);
  },

  sendResetPasswordInstructions(userParams) {
    return axios.post('users/send_reset_password_instructions', userParams);
  },
  resetPassword(userParams) {
    return axios.post('users/reset_password', userParams);
  },
};
</script>
